import { createAction } from '@reduxjs/toolkit';
import { RequestError, Callback } from 'types';
import { State } from './types';

export const fetchReasons = createAction('reasons/fetch', (callback?: Callback<unknown, void>) => ({
  payload: undefined,
  meta: { callback },
}));

export const fetchedReasons = createAction('reasons/fetched', (data?: State['data'], error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export default {
  fetchedReasons,
  fetchReasons,
};
